import React from 'react';
import { shape, string } from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { getUser } from '../../utils/auth';

const PrivateRoute = ({
  // eslint-disable-next-line react/prop-types
  component: Component,
  scrollableDiv,
  superPrivate,
  ...rest
}) => {
  const { isAuthenticated, isLoading } = useAuth0();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoading) {
          return <div>Loading...</div>;
        }

        if (isAuthenticated) {
          const user = getUser()?.user;
          if (superPrivate && superPrivate !== user?.userRole) {
            return (
              <Redirect
                to={{
                  pathname: '/',
                  state: { from: props.location },
                }}
              />
            );
          }
          return <Component scrollableDiv={scrollableDiv} {...props} />;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

PrivateRoute.defaultProps = {
  scrollableDiv: {},
  location: {},
  superPrivate: '',
};

PrivateRoute.propTypes = {
  scrollableDiv: shape({}),
  location: shape({}),
  superPrivate: string,
};

export default PrivateRoute;
